import Commons from '../../../Services/Common/Common';

/**
 * 작업중지 상세/재개 승인 (M_WOS_BASIC_02) 요청 파라미터 매핑
 * 사용처: M_WOS_BASIC_02_Query.js (useSearch1, useSave1)
 */
export const WOS_BASIC_02_Schema = {
  mapper: {
    /** useSearch1 → GetWosBasicR2 (작업중지 상세 조회) */
    search1: {
      WorkStopCd: (context) =>
        Commons.EncryptAES(context.workStopCd ?? '') || '',
    },
    /** useSave1 → SaveWosBasicU2 (SP: _WORK_STOP_CD, _SOLVE_YN, _SOLVE_ID, _SOLVE_COMMENT, _SOLVE_IMAGE_PATH, _SKIP_YN, _USER_ID) */
    save1: {
      WorkStopCd: (ctx) =>
        Commons.EncryptAES(ctx?.workStopCd ?? '') || '',
      SolveYn: (ctx) => Commons.EncryptAES(ctx?.solveYn ?? '') || '',
      SolveId: (ctx) => String(ctx?.solveId ?? ctx?.userInfo?.userid ?? ''),
      SolveComment: (ctx) =>
        Commons.EncryptAES(ctx?.solveComment ?? '') || '',
      SolveImagePath: (ctx) =>
        Commons.EncryptAES(ctx?.solveImagePath ?? '') || '',
      SkipYn: (ctx) => Commons.EncryptAES(ctx?.skipYn ?? '') || '',
      UserId: (ctx) => ctx.userInfo.userid ,
    },
  },
  fields: {
    solveComment: { required: 'N', label: '조치 내용' },
  },
};
